export default __webpack_public_path__ + "static/media/logo.f4144e88.png";